
const musicAlbums = [


{
  id: "album-15",
  name: "Random Hitz",
  cover: "rm.jpg",
  price: 1000,          // album price (optional; you can still show “Buy album” if you want)
  preorder: true,
  songs: [
    
    {
      id: "album-15-song-1",
      name: "Mountain off  you",
      title: "Mountain off  you",
      file: "random/burden.mp3",
      price: 150
    },
    {
      id: "album-15-song-2",
      name: "My Head",
      title: "My Head",
      file: "random/my head.mp3",
      price: 150
    },
    {
      id: "album-15-song-3",
      name: "Tippn4",
      title: "Tippn4",
      file: "random/tippn4.mp3",
      price: 150
      
    },
    {
      id: "album-15-song-4",
      name: "Alpo Pup",
      title: "Alpo Pup",
      file: "random/alpo Pup.mp3",
      price: 150
    },
    {
      id: "album-15-song-5",
      name: "Bush no more",
      title: "Bush no more",
      file: "random/bush no more.mp3",
      price: 150
    },
    {
      id: "album-15-song-6",
      name: "Calipillas",
      title: "Calipillas",
      file: "random/calipillas.mp3",
      price: 150
    },
    {
      id: "album-15-song-7",
      name: "Calipillas(remix)",
      title: "Calipillas(remix)",
      file: "random/calipillas2.mp3",
      price: 150
    },
    {
      id: "album-15-song-8",
      name: "Hope she don't do me wrong",
      title: "Hope she don't do me wrong",
      file: "random/hsddmw.mp3",
      price: 150
    },
    {
      id: "album-15-song-9",
      name: "I won't do him wrong",
      title: "I won't do him wrong",
      file: "random/iwdhw.mp3",
      price: 150
    },
    {
      id: "album-15-song-10",
      name: "Didn't do wrong",
      title: "Didn't do wrong",
      file: "random/ddw.mp3",
      price: 150
    },
    {
      id: "album-15-song-11",
      name: "Bitch in you",
      title: "Bitch in you",
      file: "random/biy.mp3",
      price: 150
    },
    {
      id: "album-15-song-12",
      name: "Don't start none",
      title: "Don't start none",
      file: "random/dont start none.mp3",
      price: 150
    },


     {
      id: "album-15-song-13",
      name: "Don't Blame me",
      title: "Don't Blame me",
      file: "random/dbm.mp3",
      price: 150
    },
    {
      id: "album-15-song-14",
      name: "Don't Blame me(remix)",
      title: "Don't Blame me(remix)",
      file: "random/dbmr.mp3",
      price: 150
    },


      {
      id: "album-15-song-15",
      name: "My one girl(remix)",
      title: "My one girl(remix)",
      file: "random/mog.mp3",
      price: 150
    },


         







    {
      id: "album-15-song-16",
      name: "Bout it Boo",
      title: "Bout it Boo",
      file: "random/bout it boo.mp3",
      price: 150
    }
  ],
},


  
{
id: "album-1",
name: "Christmas Joy",
        cover: "images/xmasep.jpg",
       
        preorder: true,
       songs: [
          { title: "All the little Shorties", file: "xmasepU/pre/atls.mp3" },
          { title: "Eyez of the children", file: "xmasepU/pre/eotc.mp3" },
          { title: "Slippn and Slidn in the snow", file: "xmasepU/pre/crlr.mp3" },
          { title: "Fat man in red(flying around)", file: "xmasepU/pre/fmir.mp3" },
          { title: "Santa could use more help", file: "xmasepU/pre/scumh.mp3" },
         ],
      },
      


      {
id: "album-2",
name: "Male R&b Hitz",

        cover: "mrb2.jpg",
        price: 1000,
        preorder: true,
        songs: [
          { title: "BenduOva", file: "malernbU/pre/benduova.mp3" },
          { title: "I'm coming back", file: "malernbU/pre/ComingBack.mp3" },
          { title: "Have and Hold", file: "malernbU/pre/HAVEandhold.mp3" },
          { title: "Her big payback", file: "malernbU/pre/BIGPAYback.mp3" },
          { title: "Beautiful in every way", file: "malernbU/pre/Ineveryway.mp3" },
          { title: "Top Billing", file: "malernbU/pre/TOPBILLingvidMAS1.mp3" },
          { title: "You would think", file: "malernbU/pre/youwouldthink.mp3" },
          { title: "I get up", file: "malernbU/pre/Igetup.mp3" },
          { title: "Here Dear", file: "malernbU/pre/HearDear.mp3" },
          { title: "Thatz how much", file: "malernbU/pre/thatzhowmuch.mp3" },
          { title: "Bad 4 me", file: "malernbU/pre/BAD4ME.mp3" },
         ],
      },
{
id: "album-3",
      name: "Country Hitz",
        cover: "mcountry.jpg",
        price: 1000,
        preorder: true,
        songs: [
          { title: "My one Girl", file: "countryU/pre/Myonegirl.mp3" },
          
         { title: "Your lipz(long version)", file: "countryU/pre/butyourlipx(vs2).mp3" },
          { title: "All dressed up", file: "countryU/pre/01-Alldressedup.mp3" },
          { title: "Where the bull is at", file: "countryU/pre/02-Bullisat.mp3" },
          { title: "Without you", file: "countryU/pre/WithoutYou.mp3" },
          { title: "Never love and leave", file: "countryU/pre/neverloveandleave.mp3" },
          { title: "Don't let the Girl get away", file: "countryU/pre/Getaway.mp3" },
          { title: "Your lipz", file: "countryU/pre/butyourlipz.mp3" },
          { title: "Daddies never", file: "countryU/pre/Daddiesnever.mp3" },
          { title: "Wouldn't be here", file: "countryU/pre/Wouldn'tBeHere.mp3" },
          { title: "Phenomenon", file: "countryU/pre/Phenomenon.mp3" },
          { title: "Let her go", file: "countryU/pre/LetHerGo.mp3" },
         ],
      },
{
id: "album-4",
      name: "Adult sexxxy Hitz",
        cover: "asexy.jpg",
        price: 1000,
        preorder: true,
        songs: [
          { title: "At least six", file: "adultsexxyU/pre/atleast6.mp3" },
          { title: "Over the top", file: "adultsexxyU/pre/OverTheTop.mp3" },
          { title: "No sexier", file: "adultsexxyU/pre/nosexxier.mp3" },
          { title: "Ready2rush", file: "adultsexxyU/pre/ready2rush.mp3" },
          { title: "All out of wordz", file: "adultsexxyU/pre/Alloutofwords.mp3" },
          { title: "Puddn 2night", file: "adultsexxyU/pre/pudding2nite.mp3" },
          { title: "Inside of me", file: "adultsexxyU/pre/insideofme.mp3" },
          { title: "Another zero", file: "adultsexxyU/pre/anotherzero.mp3" },
          { title: "Water", file: "adultsexxyU/pre/Water.mp3" },
          { title: "Wanna see me naked", file: "adultsexxyU/pre/nakedsee.mp3" },
          { title: "Pretty box", file: "adultsexxyU/pre/PrettyBox.mp3" },
         ],
      },
{
id: "album-5",
      name: "Girlz with guitars",
        cover: "gwg.jpg",
        preorder: true,
       price: 1000,
        songs: [
          { title: "Exist with men", file: "gwgU/pre/existwithmen.mp3" },
          { title: "Something strange", file: "gwgU/pre/somethingstrange.mp3" },
          { title: "Effing girlfriend", file: "gwgU/pre/FKINGgirlfriend.mp3" },
          { title: "Only wanna hurt", file: "gwgU/pre/onlywannahurt.mp3" },
          { title: "Pretty face", file: "gwgU/pre/prettyface.mp3" },
          { title: "MommyDaddy", file: "gwgU/pre/mommydaddy.mp3" },
          { title: "Trouble man", file: "gwgU/pre/troubleman.mp3" },
          { title: "Body U Body me", file: "gwgU/pre/bybmeremix.mp3" },
          { title: "Hero", file: "gwgU/pre/hero.mp3" },
          { title: "Sentimental", file: "gwgU/pre/sentimental.mp3" },
          { title: "Tower of peace", file: "gwgU/pre/towerofpeace.mp3" },
         ],
      },
{
id: "album-6",
      name: "Female R&b Hitz",
        cover: "frb1.jpg",
        price: 1000,
        preorder: true,
        songs: [
          { title: "Lady luck", file: "femalernbU/pre/LadyLuck.mp3" },
          { title: "Superman's Girl", file: "femalernbU/pre/SuperManGirl.mp3" },
          { title: "Love and Fantasy", file: "femalernbU/pre/LoveFantasy.mp3" },
          { title: "Sentimental", file: "femalernbU/pre/sent.mp3" },
          { title: "body you body me(remix)", file: "femalernbU/pre/bybme.mp3" },
        
          { title: "Little boy smile", file: "femalernbU/pre/BoySmile.mp3" },
          { title: "Take care of me", file: "femalernbU/pre/Business.mp3" },
          { title: "Keep it clapping", file: "femalernbU/pre/clapping.mp3" },
          { title: "Cold day", file: "femalernbU/pre/coldday.mp3" },
          { title: "Take it there", file: "femalernbU/pre/TakeItThere.mp3" },
          { title: "If I say one", file: "femalernbU/pre/ifisayone.mp3" },
          { title: "Grow up", file: "femalernbU/pre/Growup.mp3" },
         ],
      },
{
id: "album-7",
      name: "Female Pop Hitz",
        cover: "fpop.jpg",
        price: 1000,
        preorder: true,
        songs: [
          { title: "BreaknNewz", file: "femalepopU/pre/BreakNewz.mp3" },
          { title: "Don't cry", file: "femalepopU/pre/don'tcry.mp3" },
          { title: "Confess", file: "femalepopU/pre/confess.mp3" },
          { title: "Little Sister", file: "femalepopU/pre/LittleSister.mp3" },
          { title: "Pop Queen", file: "femalepopU/pre/PopQueen.mp3" },
          { title: "Just because", file: "femalepopU/pre/justbecause.mp3" },
          { title: "You know it", file: "femalepopU/pre/YouKnowIt.mp3" },
          { title: "Win my heart", file: "femalepopU/pre/WinMyheart.mp3" },
          
          { title: "How does it feel", file: "femalepopU/pre/howdoezitfeel.mp3" },
          { title: "Outside walking", file: "femalepopU/pre/outside.mp3" },
         ],
      },
{
id: "album-8",
      name: "Aphrodite body",
        cover: "abody.jpg",
        price: 1000,
        preorder: true,
        songs: [
         { title: "Betty Boop that azz", file: "aphroditeU/pre/Bettyboopdatazz.mp3" },
          { title: "Kind of wild Girl", file: "aphroditeU/pre/kindofwildgirl.mp3" },
          { title: "I know what I like", file: "aphroditeU/pre/KnowwhatIlike.mp3" },
          { title: "Heelz up", file: "aphroditeU/pre/HeelsUp.mp3" },
          { title: "Short shortz", file: "aphroditeU/pre/Shortshortz.mp3" },
          { title: "Body you Body me", file: "aphroditeU/pre/bodyyouyoubodyme.mp3" },
          { title: "Lookahere", file: "aphroditeU/pre/lookahere.mp3" },
          { title: "Can't nobody", file: "aphroditeU/pre/Likemybody.mp3" },
          { title: "Party Girl", file: "aphroditeU/pre/PartyGirl.mp3" },
          { title: "Season no reason", file: "aphroditeU/pre/Seasonsnoreason.mp3" },
          { title: "Aphrodite body", file: "aphroditeU/pre/Aphroditebody.mp3" },
         ],
      
       },
    {  
      id: "album-9",
   name: "R&b Duetz Hitz",
        cover: "rbduet.jpg",
        price: 1000,
        preorder: true,
        songs: [
        { title: "Happy Anniversary", file: "duetsU/pre/HappyAnniversary.mp3" },
          { title: "I got the heart", file: "duetsU/pre/Gottheheart.mp3" },
          { title: "Distance between us", file: "duetsU/pre/distancebetweenus.mp3" },
          { title: "Extra mile", file: "duetsU/pre/Extramile.mp3" },
          { title: "I really love you", file: "duetsU/pre/reallyloveU.mp3" },
          { title: "Feel you are the one", file: "duetsU/pre/Theone.mp3" },
          { title: "Shaking the bed", file: "duetsU/pre/Shakingthebed.mp3" },
          { title: "Heart2heart", file: "duetsU/pre/heart2heart.mp3" },
          { title: "Moment away", file: "duetsU/pre/momentaway.mp3" },
          { title: "Wanted 2 say", file: "duetsU/pre/Iwanted2say.mp3" },
          { title: "Play the heartz", file: "duetsU/pre/Playtheheartz.mp3" },
         ],
      },
{
id: "album-10",
      name: "Female R&b2 Hitz",
        cover: "frb2.jpg",
        price: 1000,
        preorder: true,
        songs: [
          { title: "Your City", file: "femalernb2U/pre/toyourcity.mp3" },
          { title: "God made it like this", file: "femalernb2U/pre/dashyt.mp3" },
          { title: "Misery wantz her lover", file: "femalernb2U/pre/Miserywantzherlover.mp3" },
          { title: "Lock you down", file: "femalernb2U/pre/lockyoudown.mp3" },
          { title: "Feeling this", file: "femalernb2U/pre/feelingthis.mp3" },
          { title: "No Finance no Romance", file: "femalernb2U/pre/NoFinance.mp3" },
          { title: "Handz in the air", file: "femalernb2U/pre/handzintheair.mp3" },
          { title: "Whereever you are", file: "femalernb2U/pre/wya.mp3" },
         { title: "Don't show", file: "femalernb2U/pre/dontshow.mp3" },
          { title: "Aint the one", file: "femalernb2U/pre/ainttheone.mp3" },
         
         ],
      },
{
id: "album-11",
      name: "New Genesis soundtrack1",
        cover: "ngst.jpeg",
       price: 1000,
        preorder: true,
        songs: [
          { title: "Not shy", file: "ngU/pre/notshy.mp3" },
          { title: "Chump get up", file: "ngU/pre/chumpgetup.mp3" },
          { title: "About 2 die", file: "ngU/pre/about2die.mp3" },
          { title: "Don't look back", file: "ngU/pre/don'tlookback.mp3" },
          { title: "Iceman friend", file: "ngU/pre/icemanfriend.mp3" },
          { title: "Too Hott", file: "ngU/pre/toohott.mp3" },
          { title: "Light of the World", file: "ngU/pre/lightoftheworld.mp3" },
          { title: "Her name is", file: "ngU/pre/hernameis.mp3" },
          { title: "Loving armz", file: "ngU/pre/lovingarmz.mp3" },
          { title: "Feifong song", file: "ngU/pre/Feifongsong.mp3" },
          { title: "Big Cat", file: "ngU/pre/bigcat.mp3" },
          { title: "Like this Like you", file: "ngU/pre/likethislikeyou.mp3" },
         ],
      },
{
id: "album-12",
      name: "New Genesis(Return) soundtrack 2",
        cover: "NEWGEN2.jpg",
        price: 1000,
        preorder: true,
        songs: [
           { title: "Your highness", file: "ng2U/pre/yourhighness.mp3" },
          { title: "Dragon by the toe", file: "ng2U/pre/Dragonbythetoe.mp3" },
          { title: "Justice", file: "ng2U/pre/Orion'sJustice.mp3" },
          { title: "I'll be free", file: "ng2U/pre/prisoner.mp3" },
          { title: "Long way 2 nowhere", file: "ng2U/pre/longway2nowhere.mp3" },
          { title: "Rootzwoman", file: "ng2U/pre/rootzwoman.mp3" },
          { title: "My mouth(remix)", file: "ng2U/pre/mymouth.mp3" },
          { title: "My mouth broke my heart", file: "ng2U/pre/mymouth1.mp3" },
          { title: "Freedom Fighter", file: "ng2U/pre/freedomfighter.mp3" },
          { title: "Day of mourning", file: "ng2U/pre/DayofMourning.mp3" },
          { title: "Chasing Rainbows", file: "femalernb2U/pre/rainbows.mp3" },
         ],
      },
{
id: "album-13",
      name: "House of Cush sountrack",
        cover: "unaccept1.jpg",
        price: 1000,
        preorder: true,
        songs: [
         { title: "InInanna", file: "houseU/pre/inInanna.mp3" },
          { title: "My Meri", file: "houseU/pre/Meri.mp3" },
          { title: "Under a Spell", file: "houseU/pre/UnderaSpellfinal.mp3" },
          { title: "Nieghborhood", file: "houseU/pre/nieghborhood.mp3" },
          { title: "Between 2 worldz", file: "houseU/pre/between2worlds.mp3" },
          { title: "Brother's eyez", file: "houseU/pre/Brother'sEyes.mp3" },
          { title: "Communist", file: "houseU/pre/imacommunist.mp3" },
          { title: "Tower of Babel", file: "houseU/pre/towerofbabel.mp3" },
          { title: "2 my love", file: "houseU/pre/2myluv.mp3" },
          { title: "Da fuck you", file: "houseU/pre/dafucku.mp3" },
          { title: "WillyDo", file: "houseU/pre/willydo.mp3" },
         ],
      },
{
       id: "album-14",
      name: "Nimrod:Lost son",
        cover: "unaccept2.jpg",
       price: 1000,
        preorder: true,
        songs: [
           { title: "Oppose the devil", file: "lostsonU/pre/opposedevil.mp3" },
           { title: "Old School", file: "lostsonU/pre/oldschool.mp3" },
           { title: "Bless U", file: "lostsonU/pre/blessu.mp3" },
           { title: "Down there", file: "lostsonU/pre/downthere.mp3" },
          { title: "Coming to get you", file: "lostsonU/pre/comn2getyou.mp3" },
          { title: "Dey come", file: "lostsonU/pre/deycome.mp3" },
          { title: "Roll with Nimrod", file: "lostsonU/pre/rollwithNimrod.mp3" },
          { title: "Black love", file: "lostsonU/pre/BlackLove.mp3" },
          { title: "Say 2 U", file: "lostsonU/pre/say2u.mp3" },
          { title: "Would it be", file: "lostsonU/pre/Woulditbe.mp3" },
          { title: "Like mind", file: "lostsonU/pre/likemind.mp3" },
          { title: "Who you praying to", file: "lostsonU/pre/pray.mp3" },
 ]
  }
]; 


export default musicAlbums;